var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap shadow-lg bg-white rounded"},[_c('secret-question-form',{attrs:{"title":_vm.$t('auth.mfa.title'),"loading":_vm.loading,"questions":_vm.questions,"submit-text":_vm.$t('common.text00117')},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }